import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'TaskOperations/'

export const taskOperationsService = {
  getAll,
  getAllHistory,
  GetByIdHistory,
  GetByIdHistoryMultiTasks,
  GetByIdSCumHistoryAsync,

  getById,
  add,
  pmAddTaskOperation,
  pmEditTaskOperation,

  prumAddTaskOperation,
  sprumAddTaskOperation,
  sprumStartTaskOperation,

  scumAddTaskOperation,
  scumStartTaskOperation,

  sclumAddTaskOperation,
  sclumStartTaskOperation,

  iumAddTaskOperation,
  siumAddTaskOperation,
  siumStartTaskOperation,

  cumAddTaskOperation,
  clumAddTaskOperation,

  whmFinishTaskOperation,

  backwardOperation,

  edit,
  delete: _delete,

  replaceProduct
}

function getAll() {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllHistory(dto) {
  const url = base_url + model + 'getAllHistory/'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function GetByIdHistory(id) {
  const url = base_url + model + 'GetByIdHistory/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function GetByIdHistoryMultiTasks(dto) {
  const url = base_url + model + 'GetByIdHistoryMultiTasks'
  console.log(url)
  console.log(dto)
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function GetByIdSCumHistoryAsync(id) {
  const url = base_url + model + 'GetByIdSCumHistoryAsync/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function pmAddTaskOperation(dto) {
  const url = base_url + model + 'pmAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function pmEditTaskOperation(dto) {
  const url = base_url + model + 'pmEditTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}

function prumAddTaskOperation(dto) {
  const url = base_url + model + 'prumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function sprumAddTaskOperation(dto) {
  const url = base_url + model + 'sprumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function sprumStartTaskOperation(dto) {
  const url = base_url + model + 'sprumStartTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function iumAddTaskOperation(dto) {
  const url = base_url + model + 'iumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function siumAddTaskOperation(dto) {
  const url = base_url + model + 'siumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function siumStartTaskOperation(dto) {
  const url = base_url + model + 'siumStartTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function cumAddTaskOperation(dto) {
  const url = base_url + model + 'cumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function scumAddTaskOperation(dto) {
  const url = base_url + model + 'scumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function scumStartTaskOperation(dto) {
  const url = base_url + model + 'scumStartTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function clumAddTaskOperation(dto) {
  const url = base_url + model + 'clumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function sclumAddTaskOperation(dto) {
  const url = base_url + model + 'sclumAddTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function sclumStartTaskOperation(dto) {
  const url = base_url + model + 'sclumStartTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function whmFinishTaskOperation(dto) {
  const url = base_url + model + 'whmFinishTaskOperation'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function backwardOperation(id) {
  const url = base_url + model + 'backwardOperation/' + id
  console.log(url)
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function edit(id, dto) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function replaceProduct(dto) {
  const url = base_url + model + 'replaceProduct'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}
